import jquery from 'jquery';

window.jQuery = jquery;
window.moment = require('moment');
window.THANOS_QUERY_URL = '';
